import React from 'react';
import { useTranslation } from 'react-i18next';
import './ExpertiseSectionPrivateCloud.css';

const ExpertiseSectionPrivateCloud: React.FC = () => {
  const { t } = useTranslation();
  
  return (
    <div className="expertise-section">
      <div className="main-text">
        <h3 className="h3-gradient">
          {t('appCloud.expertiseSection.mainText', 'IT Monkeys vous accompagne pour héberger vos applications et orchestrer des déploiements fluides, vous permettant ainsi de répondre efficacement aux besoins du marché.')}
        </h3>
      </div>
    </div>
  );
};

export default ExpertiseSectionPrivateCloud;
